import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';
import { TAssetSubType, TAssetType } from '@enums/map';

interface IInitialState extends TDefaultStoreDTO {
	assetType: TAssetType | null;
	assetSubType: TAssetSubType | null;
	unitId: string | null;
}

const initialState: IInitialState = {
	...defaultMeta,
	assetType: null,
	assetSubType: null,
	sortDirection: false,
	sortFieldName: null,
	searchValue: '',
	unitId: null,
};

const assignApprovalUnit = createSlice({
	name: 'assignApprovalUnit',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setAssetType: (state, action: PayloadAction<{ assetType: TAssetType }>) => {
			state.assetType = action.payload.assetType;
		},
		setAssetSubType: (state, action: PayloadAction<{ assetSubType: TAssetSubType }>) => {
			state.assetSubType = action.payload.assetSubType;
		},
		setUnitId: (state, action: PayloadAction<{ unitId: string }>) => {
			state.unitId = action.payload.unitId;
			state.page = initialState.page;
		},
		resetAssignApprovalUnit: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
	setSearchValue,
	setUnitId,
	setAssetType,
	setAssetSubType,
	resetAssignApprovalUnit,
} = assignApprovalUnit.actions;

export default assignApprovalUnit.reducer;
